// extracted by mini-css-extract-plugin
export default {"userDetailsPanel":"UserDetailsPanel_userDetailsPanel__y1xn5","avatarWrapper":"UserDetailsPanel_avatarWrapper__JGrgi","formsWrapper":"UserDetailsPanel_formsWrapper__rOSnE"};